/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */
import "@dia-ui/util_dotenv";

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { AppProvider } from 'app/context/AppContext';

// Use consistent styling
import 'sanitize.css/sanitize.css';

import { App } from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';

import { ThemeProvider } from 'styles/theme/ThemeProvider';

import reportWebVitals from 'reportWebVitals';


// ─────────────────────────────────────────────────────────────────────────────
// Only load and run Matomo and its console helper in production mode:
// ─────────────────────────────────────────────────────────────────────────────
import "./utils/Matomo/matomoConsole";

// Immediately log the current environment:
console.log(`[Init] REACT_APP_RUN_ENV = "${process.env.REACT_APP_RUN_ENV}".`);

if (process.env.REACT_APP_RUN_ENV === "production") {
  // In production: Matomo + ConsentManager should activate
  console.log("[Init] Production mode: Matomo + ConsentManager will run.");
  // Initialize Matomo
  const { initMatomo } = require("./utils/Matomo/matomo");
  initMatomo();
} else {
  // In development: Matomo + ConsentManager must stay disabled
  console.log("[Init] Development mode: Matomo & ConsentManager sind disabled.");
}
const store = configureAppStore();
const root = ReactDOM.createRoot(
  document.querySelector('dia-grid') as HTMLElement,
);

root.render(
  <AppProvider>
    <Provider store={store}>
      <ThemeProvider>
        <HelmetProvider>
          <React.StrictMode>
            <App/>
          </React.StrictMode>
        </HelmetProvider>
      </ThemeProvider>
    </Provider>
  </AppProvider>,
);
// Hot reloadable translation json files
//if (module.hot) {
  //module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  //});
//}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
